import { OccurrenceStepEnum } from "../enums/occurrenceStep";
import { ExportFilters } from "../hooks/useOccurrenceExport";

export const getStepInfo = (steps: { stepId: OccurrenceStepEnum, timeSpent: number, stepStart: Date, hasFinished: boolean }[]): { [key in OccurrenceStepEnum]: { [key: string]: number, total: number, hasFinished: number } } => {
    return steps.reduce((acc, curr) => {
        acc[curr.stepId] = {
            ...(acc[curr.stepId] ?? {}),
            [curr.stepStart.toISOString().split('T')[0]]: (acc[curr.stepId]?.[curr.stepStart.toISOString().split('T')[0]] ?? 0) + curr.timeSpent,
            total: (acc[curr.stepId]?.total ?? 0) + curr.timeSpent,
            hasFinished: curr.hasFinished ? 1 : 0,
        };
        return acc;
    }, {} as { [key in OccurrenceStepEnum]: { [key: string]: number, total: number, hasFinished: number } });
}

export const getFinalizedFilterValue = (finishedFilterList: string[], propFinalizedFilter?: boolean): boolean | undefined => {
    if (finishedFilterList.includes('true') && finishedFilterList.includes('false'))
        return undefined;

    if (finishedFilterList.includes('true') || propFinalizedFilter === true)
        return true;

    if (finishedFilterList.includes('false'))
        return false;

    // if (propFinalizedFilter === false) 
    //     return false;
    
    return undefined;
};

export const buildExportFilters = (filters: {
    criticalityFilter?: string | null,
    typeFilter?: string[] | null,
    startDateFilter?: { start?: string, end?: string } | null,
    updateDateFilter?: { start?: string, end?: string } | null,
    dealershipFilter?: string[] | null,
    regionalFilter?: string[] | null,
    cellFilter?: string[] | null,
    modelFilter?: string[] | null,
    stepFilter?: OccurrenceStepEnum | null,
    finishedFilter?: string[],
}, chassisList?: string[]): ExportFilters => {
    const exportFilters: ExportFilters = {};

    if (filters.criticalityFilter && filters.criticalityFilter !== "undefined") {
        exportFilters.criticality = parseInt(filters.criticalityFilter);
    }

    if (filters.startDateFilter?.start) {
        exportFilters.createdStartAt = filters.startDateFilter.start;
    }
    if (filters.startDateFilter?.end) {
        exportFilters.createdEndAt = filters.startDateFilter.end;
    }

    if (filters.updateDateFilter?.start) {
        exportFilters.updatedStartAt = filters.updateDateFilter.start;
    }
    if (filters.updateDateFilter?.end) {
        exportFilters.updatedEndAt = filters.updateDateFilter.end;
    }

    if (filters.typeFilter && filters.typeFilter.length > 0) {
        exportFilters.occurrenceType = filters.typeFilter;
    }
    if (filters.dealershipFilter && filters.dealershipFilter.length > 0) {
        exportFilters.dealershipDn = filters.dealershipFilter;
    }
    if (filters.regionalFilter && filters.regionalFilter.length > 0) {
        (exportFilters as any).regional = filters.regionalFilter;
    }
    if (filters.cellFilter && filters.cellFilter.length > 0) {
        (exportFilters as any).cell = filters.cellFilter;
    }
    if (filters.modelFilter && filters.modelFilter.length > 0) {
        (exportFilters as any).models = filters.modelFilter;
    }

    if (filters.stepFilter) {
        exportFilters.stepType = filters.stepFilter;
    }
    if (chassisList && chassisList.length > 0) {
        exportFilters.chassisList = chassisList;
    } else {
        exportFilters.chassisList = [];
    }

    if (filters.finishedFilter && filters.finishedFilter.length > 0) {
        exportFilters.finishedFilter = filters.finishedFilter;
    }

    return exportFilters;
};

export const getProtocolNumber = (occurrence: { protocolNumber?: string, osNumber?: string }): string => {
    // Check if occurrence was imported from sharepoint
    if (occurrence.osNumber?.includes('ID SHP')) {
        return occurrence.osNumber.split(' | ID SHP: ')[0];
    }

    return occurrence.protocolNumber ?? "-";
}

export const parseDate = (dateString: string | undefined): Date | undefined => {
    if (!dateString) return undefined;

    // Verifica se está no formato DD/MM/YYYY (ex: "14/10/2025")
    const ddMMyyyyRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const match = dateString.match(ddMMyyyyRegex);

    if (match) {
        const [, day, month, year] = match;
        // Cria a data no formato correto: ano-mês-dia (UTC)
        // Subtrai 1 do mês porque Date usa 0-11 para meses
        return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
    }

    // Se não estiver no formato DD/MM/YYYY, tenta parsear normalmente
    return new Date(dateString);
};